// extracted by mini-css-extract-plugin
module.exports = {"landingContainer":"LandingContainer_landingContainer__HFgoV"};